import { createContext,useState } from "react";
export const ColorSchemeContext = createContext();

export const ColorSchemeProvider = ({ children }) => {
    const themes = {

        color0 :{
            backgroundColor: '#000000',
            btnLoginAndSignupBackgroundColor: '#ccc',
            btnLangBackgroundColor:'#ccc',
            allTextColor: '#FFFFFF',
            securityAndContactButtonBorderColor: '#28ACEA',
            refundAndExpiredButtonBorderColor: '#FEE128',
            deleteAndLogoutButtonBorderColor: '#FF0000',
            validityOutsideBorderColor:'#28ACEA',
            securityAndContactButtonBackgroundColor: 'transparent',
            refundAndExpiredButtonBackgroundColor:'transparent',
            deleteAndLogoutButtonBackgroundColor:'transparent',
            avatarCameraColor:'#FFFFFF',
            emailMobileAndLoginPinTextColor:'#FFFFFF',
            emailFieldTextColor: '#FFFFFF',
            emailFieldBorderColor:'#28ACEA',
            mobileFieldTextColor: '#FFFFFF',
            mobileFieldBorderColor: '#28ACEA',
            pleaseSelectTextColor:'#ccc',
            ticDownIconColor: '#FFFFFF',
            selectUserToChangeTextColor: '#28ACEA',
            modelListTextColor:'#FFFFFF',
            selectedListFieldBorderColor: '#28ACEA',
            allDetailLeftTextColor: '#FFFFFF',
            allDescriptionTextColor: '#ccc',
            workingAndLunchTextColor:'#ccc',
            backButtonIconColor:'#FFFFFF',
            headerBackgroundColor: '#000000',
            backTextColor: '#FFFFFF',
            titleHeaderTextColor: '#FFFFFF',
            settingButtonIconColor: '#FFFFFF',
            homePageHeaderColor: '#000000',
            barMovingParkedIdlingOfflineButtonBackgroundColor:'#000000',
            movingButtonBackgroundColor:'#000000',
            parkedButtonBackgroundColor: '#000000',
            idlingButtonBackgroundColor: '#000000',
            offlineButtonBackgroundColor:'#000000',
            borderRadius: 15,
            boxVehRegAndDateBackgroundColor: '#000000',
            VehRegAndDateTextColor: '#ccc',
            locateFenceHistoryAlertAndMoreButtonTextColor:'#FFFFFF',
            accOffButtonTextColor: '#FFFFFF',
            locateButtonBackgroundColor: '#000000',
            allButtonDeviceBackgroundColor: '#000000',
            vehTrackSearchTextColor:'#FFFFFF',
            allIconsBackgroundColor: '#000000',
            allIconsColor:'#FFFFFF',
            moreModalBorderColor: '#000000',
            moreButtonMainModal:'#000000',
            pushNotificationTextColor:'#FFFFFF',
            allModalTextColor: '#FFFFFF',
            allDividerMoreButtonColor:'#28ACEA',
            moreButtonModalHeaderColor: '#28ACEA',
            moreButtonModalAllButtonsBackgroundColor:'black',
            moreButtonModalAllButtonsTextColor:'white',
            moreButtonModalCutWireCrossModalTextColor:'white',
            locatePageSimpleModalBackgroundColor: '#000000',
            locateModalDateTextColor: 'grey',
            locateModalDeviceNameTextColor: 'green',
            locateModalDeviceNumberTextColor: 'grey',
            alertPageAllDeviceTextColor: '#FFFFFF',
            otpModalBackgroundColor: '#272727',
            otpModalTextColor: '#FFFFFF',
            alertPageBackgroundColor: 'rgba(255, 255, 255, 0.1)',
            alertPageTextColor: '#FFFFFF',
            reportHistoryListingBackgroundColor: 'rgb(57,57,57)',
            reportHistoryListingTextColor: 'grey',
            allReportButtonsBackgroundColor: '#9B9B9B'
            
        },
        color1:{
            backgroundColor: '#FFFFFF',
            languageTextColor : '#000000',
            allTextColor: '#000000',
            btnLoginAndSignupBackgroundColor: '#42b8f0',
            btnLangBackgroundColor: '#42b8f0',
            validityOutsideBorderColor: '#000000',
            deleteAndLogoutButtonBorderColor: 'none',
            securityAndContactButtonBackgroundColor: '#42b8f0',
            refundAndExpiredButtonBackgroundColor: '#42b8f0',
            deleteAndLogoutButtonBackgroundColor: '#a73c2d',
            avatarCameraColor: '#000000',
            emailMobileAndLoginPinTextColor: '#000000',
            emailFieldTextColor: '#000000',
            emailFieldBorderColor: '#000000',
            mobileFieldTextColor : '#000000',
            mobileFieldBorderColor: '#000000',
            pleaseSelectTextColor:'#000000',
            ticDownIconColor: '#000000',
            selectedFieldTextColor: '#000000',
            modalBackgroundColor: '#FFFFFF',
            selectUserToChangeTextColor: '#000000',
            modelListTextColor:'#000000',
            selectedListFieldBorderColor: '#000000',
            allDetailLeftTextColor: '#000000',
            allDescriptionTextColor: '#000000',
            workingAndLunchTextColor: '#000000',
            mainTitleDetailTextColor: '#000000',
            firstThreeDetailsTextColor: '#000000',
            firstTwoBulletPointTextColor: '#000000',
            bulletPointDetailTextColor :'#000000',
            wholePageTextColor: '#000000',
            dearCustomerTextColor: '#000000',
            backButtonIconColor: '#000000',
            headerBackgroundColor: '#ccc',
            backTextColor: '#000000',
            homePageHeaderColor: '#ccc',
            titleHeaderTextColor: '#000000',
            // settingButtonIconColor: '#000000',
            barMovingParkedIdlingOfflineButtonBackgroundColor:'#FFFFFF',
            movingButtonBackgroundColor: '#FFFFFF',
            parkedButtonBackgroundColor: '#FFFFFF',
            idlingButtonBackgroundColor:'#FFFFFF',
            offlineButtonBackgroundColor: '#FFFFFF',
            borderRadius: 0,
            boxVehRegAndDateBackgroundColor: '#f0f8fb',
            fenceHistoryAlertAndMoreBackgroundColor: '#FFFFFF',
            VehRegAndDateTextColor: '#000000',
            locateFenceHistoryAlertAndMoreButtonTextColor: '#28ACEA',
            accOffButtonTextColor: '#28ACEA',
            accOffButtonBackgroundColor: '#FFFFFF',
            locateButtonBackgroundColor: '#FFFFFF',
            allButtonDeviceBackgroundColor: '#FFFFFF',
            vehTrackSearchTextColor: '#000000',
            inputFieldBackgroundBorderColor: '#000000',
            addDeviceButtonBackgroundColor: '#28ACEA',
            allIconsBackgroundColor: '#ccc',
            allIconsColor: '#000000',
            moreModalBorderColor: '#FFFFFF',
            moreButtonMainModal:'#FFFFFF',
            pushNotificationTextColor: '#000000',
            allModalTextColor: '#000000',
            allDividerMoreButtonColor:'#000000',
            moreButtonModalHeaderColor: '#ccc',
            moreButtonModalAllButtonsBackgroundColor:'white',
            moreButtonModalAllButtonsTextColor:'black',
            moreButtonModalCutWireCrossModalTextColor:'black',
            historyAlarmAndIgnitionReportBackgroundColor: '#FFFFFF',
            locatePageSimpleModalBackgroundColor: '#ccc',
            locateModalDateTextColor: 'grey',
            locateModalDeviceNameTextColor: 'green',
            locateModalDeviceNumberTextColor: 'grey',
            alertPageAllDeviceTextColor:'#000000',
            otpModalBackgroundColor: '#FFFFFF',
            otpModalTextColor: '#000000',
            alertPageBackgroundColor:'#ccc',
            alertPageTextColor: '#000000',
            reportHistoryListingBackgroundColor: '#ccc',
            reportHistoryListingTextColor: '#000000',
            allReportButtonsBackgroundColor: '#ccc'
            

        },
            color2:{
                backgroundColor: '#FFFFFF',
                languageTextColor : '#000000',
                allTextColor: '#000000',
                btnLoginAndSignupBackgroundColor: '#42b8f0',
                btnLangBackgroundColor: '#42b8f0',
                validityOutsideBorderColor: '#000000',
                deleteAndLogoutButtonBorderColor: 'none',
                securityAndContactButtonBackgroundColor: '#42b8f0',
                refundAndExpiredButtonBackgroundColor: '#42b8f0',
                deleteAndLogoutButtonBackgroundColor: '#a73c2d',
                avatarCameraColor: '#000000',
                emailMobileAndLoginPinTextColor: '#000000',
                emailFieldTextColor: '#000000',
                emailFieldBorderColor: '#000000',
                mobileFieldTextColor : '#000000',
                mobileFieldBorderColor: '#000000',
                pleaseSelectTextColor:'#000000',
                ticDownIconColor: '#000000',
                selectedFieldTextColor: '#000000',
                modalBackgroundColor: '#FFFFFF',
                selectUserToChangeTextColor: '#000000',
                modelListTextColor:'#000000',
                selectedListFieldBorderColor: '#000000',
                allDetailLeftTextColor: '#000000',
                allDescriptionTextColor: '#000000',
                workingAndLunchTextColor: '#000000',
                mainTitleDetailTextColor: '#000000',
                firstThreeDetailsTextColor: '#000000',
                firstTwoBulletPointTextColor: '#000000',
                bulletPointDetailTextColor :'#000000',
                wholePageTextColor: '#000000',
                dearCustomerTextColor: '#000000',
                backButtonIconColor: '#000000',
                headerBackgroundColor: '#ccc',
                backTextColor: '#000000',
                homePageHeaderColor: '#ccc',
                titleHeaderTextColor: '#000000',
                // settingButtonIconColor: '#000000',
                barMovingParkedIdlingOfflineButtonBackgroundColor:'#FFFFFF',
                movingButtonBackgroundColor: '#FFFFFF',
                parkedButtonBackgroundColor: '#FFFFFF',
                idlingButtonBackgroundColor:'#FFFFFF',
                offlineButtonBackgroundColor: '#FFFFFF',
                borderRadius: 0,
                boxVehRegAndDateBackgroundColor: '#f0f8fb',
                fenceHistoryAlertAndMoreBackgroundColor: '#FFFFFF',
                VehRegAndDateTextColor: '#000000',
                locateFenceHistoryAlertAndMoreButtonTextColor: '#28ACEA',
                accOffButtonTextColor: '#28ACEA',
                accOffButtonBackgroundColor: '#FFFFFF',
                locateButtonBackgroundColor: '#FFFFFF',
                allButtonDeviceBackgroundColor: '#FFFFFF',
                vehTrackSearchTextColor: '#000000',
                inputFieldBackgroundBorderColor: '#000000',
                addDeviceButtonBackgroundColor: '#28ACEA',
                allIconsBackgroundColor: '#ccc',
                allIconsColor: '#000000',
                moreModalBorderColor: '#FFFFFF',
                moreButtonMainModal:'#FFFFFF',
                pushNotificationTextColor: '#000000',
                allModalTextColor: '#000000',
                allDividerMoreButtonColor:'#000000',
                moreButtonModalHeaderColor: '#ccc',
                moreButtonModalAllButtonsBackgroundColor:'white',
                moreButtonModalAllButtonsTextColor:'black',
                moreButtonModalCutWireCrossModalTextColor:'black',
                historyAlarmAndIgnitionReportBackgroundColor: '#FFFFFF',
                locatePageSimpleModalBackgroundColor: '#ccc',
                locateModalDateTextColor: 'grey',
                locateModalDeviceNameTextColor: 'green',
                locateModalDeviceNumberTextColor: 'grey',
                alertPageAllDeviceTextColor:'#000000',
                otpModalBackgroundColor: '#FFFFFF',
                otpModalTextColor: '#000000',
                alertPageBackgroundColor:'#ccc',
                alertPageTextColor: '#000000',
                reportHistoryListingBackgroundColor: '#ccc',
                reportHistoryListingTextColor: '#000000',
                allReportButtonsBackgroundColor: '#ccc'     
         },
        color3 :{
            backgroundColor: '#FFFFFF',
            languageTextColor : '#000000',
            allTextColor: '#000000',
            btnLoginAndSignupBackgroundColor: '#42b8f0',
            btnLangBackgroundColor: '#42b8f0',
            validityOutsideBorderColor: '#000000',
            deleteAndLogoutButtonBorderColor: 'none',
            securityAndContactButtonBackgroundColor: '#42b8f0',
            refundAndExpiredButtonBackgroundColor: '#42b8f0',
            deleteAndLogoutButtonBackgroundColor: '#a73c2d',
            avatarCameraColor: '#000000',
            emailMobileAndLoginPinTextColor: '#000000',
            emailFieldTextColor: '#000000',
            emailFieldBorderColor: '#000000',
            mobileFieldTextColor : '#000000',
            mobileFieldBorderColor: '#000000',
            pleaseSelectTextColor:'#000000',
            ticDownIconColor: '#000000',
            selectedFieldTextColor: '#000000',
            modalBackgroundColor: '#FFFFFF',
            selectUserToChangeTextColor: '#000000',
            modelListTextColor:'#000000',
            selectedListFieldBorderColor: '#000000',
            allDetailLeftTextColor: '#000000',
            allDescriptionTextColor: '#000000',
            workingAndLunchTextColor: '#000000',
            mainTitleDetailTextColor: '#000000',
            firstThreeDetailsTextColor: '#000000',
            firstTwoBulletPointTextColor: '#000000',
            bulletPointDetailTextColor :'#000000',
            wholePageTextColor: '#000000',
            dearCustomerTextColor: '#000000',
            backButtonIconColor: '#000000',
            headerBackgroundColor: '#ccc',
            backTextColor: '#000000',
            // homePageHeaderColor: '#1f749d',
            titleHeaderTextColor: '#000000',
            // settingButtonIconColor: '#000000',
            barMovingParkedIdlingOfflineButtonBackgroundColor:'#FFFFFF',
            movingButtonBackgroundColor: '#FFFFFF',
            parkedButtonBackgroundColor: '#FFFFFF',
            idlingButtonBackgroundColor:'#FFFFFF',
            offlineButtonBackgroundColor: '#FFFFFF',
            borderRadius: 0,
            boxVehRegAndDateBackgroundColor: '#f0f8fb',
            fenceHistoryAlertAndMoreBackgroundColor: '#FFFFFF',
            VehRegAndDateTextColor: '#000000',
            locateFenceHistoryAlertAndMoreButtonTextColor: '#28ACEA',
            accOffButtonTextColor: '#28ACEA',
            accOffButtonBackgroundColor: '#FFFFFF',
            locateButtonBackgroundColor: '#FFFFFF',
            allButtonDeviceBackgroundColor: '#FFFFFF',
            vehTrackSearchTextColor: '#000000',
            inputFieldBackgroundBorderColor: '#000000',
            addDeviceButtonBackgroundColor: '#28ACEA',
            allIconsBackgroundColor: '#ccc',
            allIconsColor: '#000000',
            moreModalBorderColor: '#FFFFFF',
            moreButtonMainModal:'#FFFFFF',
            pushNotificationTextColor: '#000000',
            allModalTextColor: '#000000',
            allDividerMoreButtonColor:'#000000',
            moreButtonModalHeaderColor: '#ccc',
            moreButtonModalAllButtonsBackgroundColor:'white',
            moreButtonModalAllButtonsTextColor:'black',
            moreButtonModalCutWireCrossModalTextColor:'black',
            historyAlarmAndIgnitionReportBackgroundColor: '#FFFFFF',
            locatePageSimpleModalBackgroundColor: '#236d96',
            locateModalDateTextColor: '#FFFFFF',
            locateModalDeviceNameTextColor: '#bad7f1',
            locateModalDeviceNumberTextColor: '#bad7f1',
            otpModalBackgroundColor: '#FFFFFF',
            otpModalTextColor: '#000000',
            alertPageBackgroundColor:'#236d96',
            alertPageTextColor: '#FFFFFF',
            reportHistoryListingBackgroundColor: '#236d96',
            reportHistoryListingTextColor: '#bad7f1',
            allReportButtonsBackgroundColor: '#236d96'
            
        }
        
    };
    const [activeColorScheme,setActiveColorScheme] = useState(themes.color0); //set initial active color here
    const [appType, setAppType] = useState(1);

    const setColorByAppType = type => {
        const selectedColor = themes[`color${type}`];
        setAppType(type);
        setActiveColorScheme(selectedColor || themes.color1);
    }
    return(
        <ColorSchemeContext.Provider value = {{ activeColorScheme, setColorByAppType, appType }}>
        {children}
        </ColorSchemeContext.Provider>
    );
};